import { useEffect } from "react";

declare global {
  interface Window {
    prerenderReady?: boolean;
  }
}

/**
 * Signals to Netlify Prerender that the page is ready to be snapshotted.
 * @param ready - Set to true when essential content has rendered.
 */
export const usePrerenderReady = (ready: boolean = true) => {
  useEffect(() => {
    if (ready && typeof window !== "undefined") {
      window.prerenderReady = true;
    }
  }, [ready]);
};
